import { apiGet } from '../js/api';
import server from '../js/config/_server';

/**
 * @returns Promise
 */
export const fetchFAQs = (language) => {
    const url = server.baseUrl + server.services.faqs.getAll + `?language=${language}`;
    return apiGet(url);
};
